import {
  cleanParentIds,
} from '../../lib/graphIdSafety';

/*
 * CC-TREE-LIVE-003G3WI5A
 *
 * Shared production row -> GraphMember structural projection.
 *
 * This module intentionally owns no React, Supabase, browser,
 * credential, database-write, relationship-authoring, or topology
 * behavior. It preserves the mapping previously private to
 * FamilyGraphContext.
 */
export const mapTreeRuntimeGraphMemberRow = (
  r: any,
) => ({
  id:
    r.id,

  ownerUserId:
    r.owner_user_id,

  name:
    r.name,

  nickname:
    r.nickname ?? null,

  treeNamePreference:
    r.metadata &&
    typeof r.metadata === 'object' &&
    r.metadata.tree_name_preference === 'nickname'
      ? 'nickname'
      : 'real-name',

  relationship:
    r.relationship,

  side:
    r.side,

  photoUrl:
    r.photo_url ?? null,

  birthYear:
    r.birth_year ?? null,

  birthDate:
    r.birth_date ?? null,

  birthMonth:
    r.birth_month ?? null,

  birthDay:
    r.birth_day ?? null,

  birthdayVisibility:
    r.birthday_visibility ?? 'public',

  birthdayReminders:
    r.birthday_reminders ?? true,

  livingStatus:
    r.living_status ?? null,

  notes:
    r.notes ?? null,

  city:
    r.city ?? null,

  description:
    r.description ?? null,

  approvalStatus:
    r.approval_status,

  confirmationsCount:
    r.confirmations_count ?? 0,

  createdBy:
    r.created_by ?? null,

  createdAt:
    r.created_at,

  parentIds:
    Array.isArray(r.parent_ids)
      ? cleanParentIds(r.parent_ids)
      : [],

  spouseId:
    r.spouse_id ?? null,

  profileState:
    r.profile_state ?? 'placeholder',

  claimedByUserId:
    r.claimed_by_user_id ?? null,

  claimedAt:
    r.claimed_at ?? null,

  authEmail:
    r.auth_email ??
    r.email ??
    null,

  relationshipOverride:
    r.relationship_override ?? null,

  branchOwnerMemberId:
    (
      r.metadata &&
      typeof r.metadata === 'object'
        ? r.metadata.branch_owner_member_id ?? null
        : null
    ) ?? null,

  relationshipWorkflow:
    r.metadata &&
    typeof r.metadata === 'object' &&
    r.metadata.relationship_workflow &&
    typeof r.metadata.relationship_workflow === 'object'
      ? r.metadata.relationship_workflow
      : null,
});
